import variants from "./imgVariants.json";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const GUARDED = /\/api\/photos\/bethel-center\/img\/[a-f0-9]{16}\.webp$/;

export const resolveSrc = (src) => (src && src.startsWith("/api") ? `${BACKEND}${src}` : src);

export const thumbOf = (src) => {
  const m = (src || "").match(/\/img\/firstparty\/[^/?]+\.webp$/);
  const v = m ? variants[m[0]] : null;
  return (v && v.t) || resolveSrc(src);
};

export default function SmartImg({ src, sizes = "100vw", ...rest }) {
  const resolved = resolveSrc(src);
  const m = (src || "").match(/\/img\/firstparty\/[^/?]+\.webp$/);
  const v = m ? variants[m[0]] : null;
  let srcSet;
  if (v && v.m) srcSet = `${v.m} 800w, ${m[0]} ${v.w}w`;
  else if (GUARDED.test(src || "")) srcSet = `${resolved.replace(/\.webp$/, "-800.webp")} 800w, ${resolved} 1600w`;
  return <img srcSet={srcSet} sizes={srcSet ? sizes : undefined} src={resolved} {...rest} />;
}
